export const buildElementJSON = <T extends Record<string, unknown>>(
  id: string,
  type: string,
  data: T
): { id: string; type: string } & T => ({
  id,
  type,
  ...data,
});
